Shopware.Component.override('sw-extension-card-base', () => import('./component/sw-extension-card-base'));
